module.exports = __webpack_public_path__ + "static/wellpay_logo-14baeeeafb965d4e3645301a5ec2dbe3.png";